/* tslint:disable */
 
import { MainWorkflowStep } from './main-workflow-step';
export class EntryMainWorkflowStatusDto {
  isMainFlowDetermined?: boolean;
  steps?: Array<MainWorkflowStep>;
  workflowId: string;
}
